import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axios';

// GET - Listado de configuraciones
export const fetchPunishmentConfigs = createAsyncThunk(
  'cartera/fetchPunishmentConfigs',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`api/v1/collections/cm-punishment-configuration/`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al obtener configuraciones');
    }
  }
);

// POST - Crear configuración
export const createPunishmentConfig = createAsyncThunk(
  'cartera/createPunishmentConfig',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`api/v1/collections/cm-punishment-configuration/`, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'Error al crear configuración');
    }
  }
);

export const updatePunishmentConfig = createAsyncThunk(
  'cartera/updatePunishmentConfig',
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`api/v1/collections/cm-punishment-configuration/${uuid}/`, data);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const carteraReglasSlice = createSlice({
  name: 'carteraReglas',
  initialState: {
    punishmentConfigs: [],
    loading: false,
    error: null,
    createLoading: false,
    createError: null,
    createSuccess: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET - listado
      .addCase(fetchPunishmentConfigs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPunishmentConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.punishmentConfigs = action.payload;
      })
      .addCase(fetchPunishmentConfigs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // POST - crear
      .addCase(createPunishmentConfig.pending, (state) => {
        state.createLoading = true;
        state.createError = null;
        state.createSuccess = false;
      })
      .addCase(createPunishmentConfig.fulfilled, (state, action) => {
        state.createLoading = false;
        state.createSuccess = true;
      })
      .addCase(createPunishmentConfig.rejected, (state, action) => {
        state.createLoading = false;
        state.createError = action.payload;
        state.createSuccess = false;
      });
  },
});

export default carteraReglasSlice.reducer;
